import { adminSession } from './session';

export const saveAuthData = (user, { expiresIn, expiresAt } = {}) => {
  adminSession.setSession(user, { expiresIn, expiresAt });
};

export const clearAuthData = () => {
  adminSession.clear();
};
